import { render, staticRenderFns } from "./forms-select.vue?vue&type=template&id=3383f1c2&scoped=true"
import script from "./forms-select.vue?vue&type=script&lang=js"
export * from "./forms-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3383f1c2",
  null
  
)

export default component.exports